import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { loginUser, sendOTP, verifyOTP } from "../../services/AdminServices";

const LoginForm = ({ redirectID, redirectPath }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOTP] = useState("");
  const [otpVerified, setOTPVerified] = useState(false);
  const [resendCoolDown, setResendCoolDown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [token, setToken] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();
  const handleLogin = async (isGuest = false) => {
    setLoading(true);
    try {
      const response = await loginUser(
        isGuest ? process.env.REACT_APP_GUEST_EMAIL : email,
        isGuest ? process.env.REACT_APP_GUEST_PASSWORD : password
      );

      if (!response.user || !response.token) {
        throw new Error("Invalid login response. User or token missing.");
      }
      // console.log("Login response:", response);
      setLoggedInUser(response.user);
      setToken(response.token);
      // if user type contains any of the values in REACT_APP_OTP_TYPES OTP is needed
      const noOTPTypes = (process.env.REACT_APP_NO_OTP_TYPES || "").split(",").map((type) => type.trim());
      const loggedInUserTypes = typeof response?.user?.userType === "string"
        ? response.user.userType.split(",").map((type) => type.trim())
        : [];
      
      console.log("otpTypes:", noOTPTypes);
      console.log("loggedInUserTypes:", loggedInUserTypes);
      
      // OTP is required if no matching user type is found in noOTPTypes
      const isOtpRequired = !loggedInUserTypes.some((type) => noOTPTypes.includes(type));
      
      console.log("otpNeeded :", isOtpRequired);
      if (!isOtpRequired) {
        setOTPVerified(true);
        await login({ userData: response.user, token: response.token });
        console.log("redirectID :", redirectID);
        console.log("redirectPath :", redirectPath);
        console.log("loggedInUser.defaultPage :", response.user.defaultPage);
        if (redirectID) {
          navigate(`/retreat-registration?id=${redirectID}`);
        } else if (redirectPath) {
          navigate(redirectPath);
        } else if (response.user && response.user.defaultPage) {
          navigate(response.user.defaultPage);
        } else {
          navigate("/");
        }
        localStorage.removeItem("previousPath");
      } else if (response.user.phone) {
        setOTPVerified(false);
        setResendCoolDown(30);
        await sendOTP(email, response.user.phone, "", "LOGIN");
        showAlert("OTP sent to your registered Phone.", "success");
      }
    } catch (error) {
      console.error("Error during login error:", error);
      console.error("Error during login error:", error.status);
      if (error.status && error.status === 401) {
        showAlert(
          <>
            {error.response.data.message}
            {"  :  "}
            <a href="/forgotPassword" className="alert-link">
              Forgot Password?
            </a>
          </>,
          "danger"
        );
      } else {
        showAlert(error.message, "danger");
      }
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const revalidateToken = async () => {
    try {
      const response = await loginUser(email, password);
      const token = response.token;
      if (!token) {
        throw new Error("Token revalidation failed.");
      }
      await login({ token });
      console.log("Token revalidated successfully.");
    } catch (error) {
      console.error("Error during token revalidation:", error);
      showAlert(error.message, "danger");
    }
  };
  const handleVerifyOTP = async (e) => {
    console.log("handleVerifyOTP", otp, loggedInUser?.phone);
    e.preventDefault();
    try {
      const response = await verifyOTP(
        otp,
        "",
        loggedInUser?.phone,
        "LOGIN",
        ""
      );
      if (response.data.status === "approved") {
        login({ userData: loggedInUser, token: token });
        setOTPVerified(true);
        showAlert("OTP verified successfully.", "success");
        if (redirectID) {
          navigate(`/retreat-registration?id=${redirectID}`);
        } else if (redirectPath) {
          navigate(redirectPath);
        } else if (loggedInUser && loggedInUser.defaultPage) {
          navigate(loggedInUser.defaultPage);
        } else {
          navigate("/");
        }
        localStorage.removeItem("previousPath");
      } else {
        showAlert("Invalid OTP. Please try again.", "danger");
      }
    } catch {
      showAlert("Error verifying OTP. Please try again.", "danger");
    }
  };

  useEffect(() => {
    if (resendCoolDown > 0) {
      const timer = setTimeout(
        () => setResendCoolDown(resendCoolDown - 1),
        1000
      );
      return () => clearTimeout(timer);
    }
    console.log("redirectID :", redirectID);
  }, [resendCoolDown]);
  const handleSignUp = () => {
    navigate(`/signup?redirectID=${redirectID}`); // Navigate to the signup page with redirectID
  };

  const handleCancel = () => {
    setToken(null);
    setOTPVerified(false);
    setLoggedInUser(null);
    navigate(-1); // Navigate back to the previous page
  };

  const showAlert = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setTimeout(() => {
      setAlertMessage("");
      setAlertType("");
    }, 6000); // Remove alert after 6 seconds
  };

  return (
    <div className="container">
      {alertMessage && (
        <div className={`alert alert-${alertType}`}>{alertMessage}</div>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
        className="contact-form mt-4"
      >
        <div className="input-group mb-3">
          <span className="input-group-text">
            <i className="fas fa-envelope"></i>
          </span>
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text">
            <i className="fas fa-key"></i>
          </span>
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {!otpVerified && loggedInUser && (
          <>
            <div className="input-group mb-3">
              <span className="input-group-text">
                <i className="fas fa-lock"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="OTP"
                value={otp}
                onChange={(e) => setOTP(e.target.value)}
                required
              />
            </div>
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => resendCoolDown === 0 && setResendCoolDown(30)}
              disabled={resendCoolDown > 0}
            >
              Resend OTP ({resendCoolDown}s)
            </button>
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={handleVerifyOTP}
              disabled={loading}
            >
              {otpVerified ? "Verified" : loading ? "Sending" : "Verify OTP"}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-light me-2"
              disabled={loading}
            >
              Cancel
            </button>
          </>
        )}
        {!loggedInUser && (
          <div className="d-flex justify-content-between gap-4 mb-3">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-light flex-grow-1"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSignUp}
              className="btn btn-secondary flex-grow-1"
              disabled={loading}
            >
               {redirectID ? "Sign Up with us and Register" : "Sign Up"}
            </button>
            {redirectID && (
              <button
                type="button"
                className="btn btn-info flex-grow-1"
                onClick={() => handleLogin(true)}
                disabled={loading}
              >
                Continue as Guest
              </button>
            )}
            <button
              type="submit"
              className="btn btn-primary flex-grow-1"
              disabled={loading}
            >
              {loading ? "Logging In..." : "Login"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default LoginForm;
